export default __webpack_public_path__ + "static/media/247uptime-logo.4cfdb310.svg";